import { GatewayEntreprise } from "@conformite/gateway";
import { displayErrorToast } from "@endya-conformite/ui-kit";
import { ParcoursAction } from "@src/parcours/NavigationButtons/ParcoursAction";
import { SaveAndQuitButton } from "@src/parcours/NavigationButtons/SaveAndQuitButton";
import { ParcoursFullPageTemplate } from "@src/parcours/Template/ParcoursFullPageTemplate";
import {
  getCreateEntrepriseParamsRenouvellement,
  storeEntrepriseCreationRequest,
} from "@src/payment/utils/createEntreprises";
import {
  ParcoursRenouvellementStepComponentProps,
  RenouvellementStepEnum,
} from "@src/renouvellement/ParcoursRenouvellement.definition";
import { useRenouvellementOffert } from "@src/renouvellement/useRenouvellementOffert";
import { contactMediationValidationSchema } from "@src/societes/form/EntrepriseContactMediationForm";
import { useEntreprises } from "@src/store/store.entreprise";
import { useMe } from "@src/store/store.me";
import { useNavigate } from "react-router-dom";
import { ResumeBlock } from "./RenouvellementResumeEntreprisePage";
import { ResumeContactMediation } from "./ResumeContactMediation";

export function RenouvellementResumeEntrepriseRenouvellementOffertPage({
  changeStep,
  data,
  addData,
  handleQuit,
}: ParcoursRenouvellementStepComponentProps) {
  const { success: isContactMediationValid } =
    contactMediationValidationSchema.safeParse(data.resume.contactMediation);

  const { me } = useMe();
  const navigate = useNavigate();
  const { entreprisesBySiren } = useEntreprises();
  const renouvellementOffert = useRenouvellementOffert();

  if (!me || !entreprisesBySiren) return <div />;
  return (
    <ParcoursFullPageTemplate
      actions={
        <>
          <SaveAndQuitButton onClick={handleQuit} />
          <ParcoursAction
            onClick={() => {
              const newData = {
                ...data,
                entreprisesAControler: Object.fromEntries(
                  Object.entries(data.entreprisesAControler).map(
                    ([key, entrepriseAController]) => [
                      key,
                      {
                        ...entrepriseAController,
                        chiffreAffaire:
                          entreprisesBySiren[entrepriseAController.siren]
                            .chiffreAffaire,
                      },
                    ]
                  )
                ),
              };
              addData(newData);
              if (!renouvellementOffert) {
                console.error(
                  "Le renouvellement doit être offert pour continuer sur cette page"
                );
                displayErrorToast("Une erreur inconnue est survenue");
                return;
              }
              const createEntrepriseParams =
                getCreateEntrepriseParamsRenouvellement(
                  null,
                  newData,
                  renouvellementOffert
                );
              storeEntrepriseCreationRequest(
                data.typeAdhesion as GatewayEntreprise.TypeAdhesionActive,
                createEntrepriseParams
              );
              navigate("/renouvellement/maj-entreprises");
            }}
            disabled={!isContactMediationValid}
          >
            Suivant
          </ParcoursAction>
        </>
      }
    >
      <ResumeBlock
        title="Identification"
        changeStep={() => changeStep(RenouvellementStepEnum.CONTACT_MEDIATION)}
        isValid={isContactMediationValid}
      >
        <ResumeContactMediation data={data} isValid={isContactMediationValid} />
      </ResumeBlock>
    </ParcoursFullPageTemplate>
  );
}
